import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm">
      <h2 className="text-2xl font-bold text-slate-950">Page not found</h2>
      <p className="mt-2 text-slate-600">
        This page is unavailable. Return to the point of sale to continue.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex rounded-lg bg-slate-900 px-4 py-2.5 font-medium text-white hover:bg-slate-800"
      >
        Return to POS
      </Link>
    </section>
  );
}
